import { render } from "./DataTemplate.vue?vue&type=template&id=456ec880&scoped=true"
import script from "./DataTemplate.vue?vue&type=script&lang=js"
export * from "./DataTemplate.vue?vue&type=script&lang=js"

import "./DataTemplate.vue?vue&type=style&index=0&id=456ec880&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-456ec880"]])

export default __exports__